<template>
  <div class="content_page">
    <Tabbar :title="$t('withdrawAccount.bindThirdPartyTitle', [channel])"></Tabbar>
    <WithdrawStepper v-if="fromBasicLevel" />
    <div class="content_area">
      <Tip v-if="withdrawType === 14" :content="$t('withdrawAccount.bindNote2')" />
      <Tip v-else :content="$t('withdrawAccount.bindNote')" />
      <div class="content_item">
        <CommonFormItem :label="$t('common.firstName')">
          <CommonInput :value="this.$store.state.userInfo.firstName" theme="white" type="text" disabled />
        </CommonFormItem>
      </div>
      <div v-if="this.$store.state.userInfo.middleName" class="content_item">
        <CommonFormItem :label="$t('common.middleName')">
          <CommonInput :value="this.$store.state.userInfo.middleName" theme="white" type="text" disabled />
        </CommonFormItem>
      </div>
      <div v-if="this.$store.state.userInfo.lastName" class="content_item">
        <CommonFormItem :label="$t('common.lastName')">
          <CommonInput :value="this.$store.state.userInfo.lastName" theme="white" type="text" disabled />
        </CommonFormItem>
      </div>
      <div v-if="withdrawType === 14" class="content_item">
        <CommonFormItem :label="$t('withdrawAccount.usdtAddress')">
          <CommonInput
            v-model="account"
            maxLength="34"
            :placeholder="$t('withdrawAccount.trc20Placeholder')"
            theme="white"
            type="text"
          />
        </CommonFormItem>
      </div>
      <div v-else class="content_item">
        <CommonFormItem :label="$t('account.account')">
          <CommonInput
            v-model="account"
            theme="white"
            type="text"
            :placeholder="$t('withdrawAccount.accountPlaceholder')"
          />
        </CommonFormItem>
      </div>
      <div v-if="withdrawType === 18 || withdrawType === 19" class="content_item">
        <CommonFormItem :label="$t('bankData.documentId')">
          <CommonInput
            v-model="documentId"
            theme="white"
            inputmode="numeric"
            type="tel"
            :placeholder="$t('bankData.documentIdPlaceholder')"
          />
        </CommonFormItem>
      </div>
      <div v-if="withdrawType === 14" class="done_btn_area">
        <CommonBtn class="done_btn" :text="$t('common.done')" :on-click="bindThirdPartyPay" :disabled="!isShow" />
      </div>
      <div v-else class="done_btn_area">
        <CommonBtn class="done_btn" :text="$t('common.done')" :on-click="bindThirdPartyPay" />
      </div>
    </div>
    <div v-if="withdrawType === 14" class="content_item_tip" :class="[$store.state.isMirroring && 'mirror']">
      <p>{{ $t('withdrawAccount.minimumLimit') }}</p>
      <p>{{ $t('withdrawAccount.usdtFee') }}</p>
    </div>
    <div v-if="withdrawType === 4" class="content_item_tip" :class="[$store.state.isMirroring && 'mirror']">
      <a href="https://gcsh.app/r/hWlkIm1" target="_blank" style="color: red">
        {{ $t('withdrawAccount.registerGcash') }}
      </a>
    </div>
    <div v-if="withdrawType === 11" class="content_item_tip" :class="[$store.state.isMirroring && 'mirror']">
      <a href="https://www.epay.com/epayweb/user/register?lang=EN_US" target="_blank" style="color: red">
        {{ $t('withdrawAccount.registerEpay') }}
      </a>
    </div>
  </div>
</template>

<script>
import Tabbar from '@/components/Tabbar.vue'
import WithdrawStepper from '@/components/WithdrawStepper.vue'
import CommonFormItem from '@/components/CommonFormItem'
import CommonInput from '@/components/CommonInput'
import CommonBtn from '@/components/CommonBtn'
import Tip from '@/components/LinkAccount/Tip'
import { Toast } from 'vant'
import debounce from 'lodash/debounce'

export default {
  name: 'BindThirdPartyPayAccount',
  components: {
    Tabbar,
    WithdrawStepper,
    CommonFormItem,
    CommonInput,
    CommonBtn,
    Tip
  },
  data() {
    return {
      channel: '',
      account: '',
      documentId: '',
      withdrawType: undefined,
      isShow: false
    }
  },
  computed: {
    fromBasicLevel() {
      return this.$route.query.from === 'BasicLevel'
    }
  },
  mounted() {
    switch (this.$route.name) {
      case 'BindGcashAccount':
        this.channel = 'GCash'
        this.withdrawType = 4
        break
      case 'BindGoPayAccount':
        this.channel = 'GoPay'
        this.withdrawType = 7
        break
      case 'BindOVOAccount':
        this.channel = 'OVO'
        this.withdrawType = 8
        break
      case 'BindDANAAccount':
        this.channel = 'DANA'
        this.withdrawType = 9
        break
      case 'BindPayPalAccount':
        this.channel = 'PayPal'
        this.withdrawType = 10
        break
      case 'BindEPayAccount':
        this.channel = 'Epay'
        this.withdrawType = 11
        break
      case 'BindUSDTAccount':
        this.channel = 'USDT (TRC-20)'
        this.withdrawType = 14
        break
      case 'BindQiwiAccount':
        this.channel = 'Qiwi'
        this.withdrawType = 13
        break
      case 'BindUPIAccount':
        this.channel = 'UPI'
        this.withdrawType = 17
        break
      case 'BindJazzCash':
        this.channel = 'Jazz Cash'
        this.withdrawType = 18
        break
      case 'BindEasyPaisa':
        this.channel = 'Easy Paisa'
        this.withdrawType = 19
        break
      default:
        break
    }
  },
  watch: {
    account: function (value) {
      const regex = /^T[A-Z0-9a-z]{33}$/
      if (this.withdrawType === 14 && value && value.length === 34) {
        if (regex.test(this.account)) {
          this.isShow = true
        } else {
          Toast(this.$t('withdrawAccount.wrongAccountToast'))
        }
      } else {
        this.isShow = false
      }
    }
  },
  methods: {
    isValidEmail(email) {
      // 邮箱地址的正则表达式模式
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

      // 使用正则表达式模式进行匹配
      return emailPattern.test(email)
    },
    isValidDocumentId(documentId) {
      const documentIdPattern = /^[0-9]+$/
      return documentIdPattern.test(documentId)
    },
    search(event) {
      if (event.target._value.length === 34) {
        this.isShow = true
      } else {
        this.isShow = false
      }
    },
    bindThirdPartyPay: debounce(
      function () {
        console.log('bindThirdPartyPay')
        if (!this.account) {
          Toast(this.$t('withdrawAccount.accountEmptyToast'))
          return
        }
        // Gcash
        if (this.withdrawType === 4 && !this.account.match(/^09\d{9}$/)) {
          Toast(this.$t('withdrawAccount.accountFormatToast'))
          return
        }
        // Epay
        if (this.withdrawType === 11 && !this.isValidEmail(this.account)) {
          Toast(this.$t('withdrawAccount.accountFormatToast'))
          return
        }
        if ((this.withdrawType === 18 || this.withdrawType === 19) && !this.isValidDocumentId(this.documentId)) {
          Toast(this.$t('withdrawAccount.documentIdToast'))
          return
        }
        const data = {
          account: this.account,
          withdrawType: this.withdrawType
        }
        if (this.withdrawType === 17) {
          data.name = this.$store.state.userInfo.firstName
          this.$store.state.userInfo.middleName && (data.name += ' ' + this.$store.state.userInfo.middleName)
          this.$store.state.userInfo.lastName && (data.name += ' ' + this.$store.state.userInfo.lastName)
        }
        if (this.withdrawType === 18 || this.withdrawType === 19) {
          data.documentId = this.documentId
        }
        this.$http
          .post(window.serverPath + '/api/account/bindThirdPartyPay', data)
          .then((res) => {
            if (res.data && res.data.code === '200') {
              if (this.$route.query.from === 'BasicLevel') {
                this.$router.replace({ name: 'Withdrawal' })
              } else if (this.$route.query.hasOwnProperty('redirect')) {
                this.$router.replace({ name: this.$route.query.redirect })
              } else {
                this.$router.back()
              }
            } else {
              Toast(this.$t('withdrawAccount.bindThirdPartyFailedToast', [this.channel]))
            }
          })
          .catch((err) => console.log(err))
      },
      1000,
      { leading: true, trailing: false }
    )
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content_page {
  width: 100%;
  background-color: #fff;
  position: relative;
  height: 100%;
  overflow-y: auto;
  scrollbar-width: 0;
}

.content_page::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.content_area {
  width: 100%;
  padding: 0 0.16rem;
  box-sizing: border-box;
}

.content_item {
  width: 100%;
  margin-bottom: 0.12rem;
}

.content_item_tip {
  width: calc(100% - 0.32rem);
  margin: 0.12rem 0.16rem;
  border-radius: 0.08rem;
  border: 0.005rem solid rgba(255, 132, 11, 0.4);
  background: rgba(255, 199, 20, 0.1);
  padding: 0.06rem 0.12rem;
  box-sizing: border-box;
  color: #ff840b;
  font-family: 'PingFang SC';
  font-size: 0.1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 0.18rem;
  text-align: left;
}

.content_item_tip.mirror {
  text-align: right;
}

.done_btn_area {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 0.86rem;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-top: 1px solid #eeeef7;
  padding: 0.18rem;
  background: #ffffff;
}

.done_btn {
  font-size: 0.16rem !important;
  width: 100% !important;
}

.content_item_tip {
  margin-top: 0.12rem;
  position: relative;
  height: 0.48rem;
  font-size: 0.1rem;
  color: #ff840b;
  padding: 0.06rem 0.14rem;
  text-align: left;
  border-radius: 0.08rem;
  border: 0.005rem solid rgba(255, 132, 11, 0.4);
  background: rgba(255, 199, 20, 0.1);
  line-height: 0.18rem;
  z-index: 2;
  display: flex;
  align-items: center;
}
.content_item_tip.mirror {
  text-align: right;
}

.required_icon {
  width: 0.08rem;
  height: 0.08rem;
}

.next_btn {
  margin-top: 0.28rem;
  width: 100% !important;
  font-size: 0.16rem !important;
}
</style>



// WEBPACK FOOTER //
// src/views/BindThirdPartyPayAccount.vue